import React from 'react';

export default class Stats extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <p 
          className={this.props.totalAttemptedClass}>
          Number Attempted: {this.props.totalAttempted}
        </p>
        <p
          className={this.props.totalCorrectClass}>
          Number Correct: {this.props.totalCorrect}
        </p>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/shared_components/stats.js
 **/